import React from 'react'

const SaveFilled = ({ color = '#e35e50', onClick }) => {
  return (
    <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg"      style={{ cursor: 'pointer' }}
    onClick={onClick}>
    <path d="M11.5 0H1H0.5V15.5L6 13L11.5 15.5V0Z" fill="#808080"/>
    </svg>
    
  )
}

export default SaveFilled
